import React from "react";
import { FaTimes } from "react-icons/fa";

interface SecurityAlertProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const SecurityAlert: React.FC<SecurityAlertProps> = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 font-['Inter',sans-serif]">
      <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl">
        {/* Header */}
        <div className="bg-gradient-to-r from-orange-500 to-red-500 p-6 rounded-t-2xl flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="bg-yellow-400 rounded-full p-2">
              <svg className="w-6 h-6 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <h2 className="text-xl md:text-2xl font-bold text-white">
              Security Alert / सुरक्षा चेतावनी
            </h2>
          </div>
          <button
            onClick={onClose}
            className="text-white hover:bg-white/20 rounded-full p-2 transition"
          >
            <FaTimes className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          {/* Alert 1 */}
          <div className="flex gap-3">
            <div className="flex-shrink-0">
              <div className="bg-green-500 rounded-full p-1.5">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <div>
              <p className="text-[#2C3E50] text-sm md:text-base">
                <span className="font-bold">English:</span> Fraudsters are sending fake payment requests via WhatsApp, SMS, and social media, impersonating mysalaryloan.com employees. Stay alert.
              </p>
              <p className="text-[#2C3E50]/80 mt-2 text-sm md:text-base">
                <span className="font-bold">हिंदी:</span> धोखेबाज WhatsApp, SMS और सोशल मीडिया के माध्यम से नकली भुगतान अनुरोध भेज रहे हैं, जो mysalaryloan.com के कर्मचारियों के रूप में दिखाई दे रहे हैं। सतर्क रहें।
              </p>
            </div>
          </div>

          {/* Alert 2 */}
          <div className="flex gap-3">
            <div className="flex-shrink-0">
              <div className="bg-green-500 rounded-full p-1.5">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <div>
              <p className="text-[#2C3E50] text-sm md:text-base">
                <span className="font-bold">English:</span> Do not click unknown links or reply to suspicious messages.
              </p>
              <p className="text-[#2C3E50]/80 mt-2 text-sm md:text-base">
                <span className="font-bold">हिंदी:</span> अज्ञात लिंक पर क्लिक न करें या संदिग्ध संदेशों का उत्तर न दें।
              </p>
            </div>
          </div>

          {/* Alert 3 */}
          <div className="flex gap-3">
            <div className="flex-shrink-0">
              <div className="bg-green-500 rounded-full p-1.5">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <div>
              <p className="text-[#2C3E50] text-sm md:text-base">
                <span className="font-bold">English:</span> Verify email IDs and domains before engaging.
              </p>
              <p className="text-[#2C3E50]/80 mt-2 text-sm md:text-base">
                <span className="font-bold">हिंदी:</span> संपर्क होने से पहले ईमेल ID और डोमेन सत्यापित करें।
              </p>
            </div>
          </div>

          {/* Alert 4 */}
          <div className="flex gap-3">
            <div className="flex-shrink-0">
              <div className="bg-green-500 rounded-full p-1.5">
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
            <div>
              <p className="text-[#2C3E50] text-sm md:text-base">
                <span className="font-bold">English:</span> Be cautious of calls or messages claiming to be from us.
              </p>
              <p className="text-[#2C3E50]/80 mt-2 text-sm md:text-base">
                <span className="font-bold">हिंदी:</span> हमारे होने का दावा करने वाले कॉल या संदेशों से सावधान रहें।
              </p>
            </div>
          </div>

          {/* Warning Box */}
          <div className="bg-orange-50 border-l-4 border-orange-500 p-4 rounded">
            <div className="flex gap-3">
              <div className="flex-shrink-0">
                <div className="bg-yellow-400 rounded-full p-1.5">
                  <svg className="w-4 h-4 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
              <div>
                <p className="text-[#2C3E50] text-sm md:text-base">
                  <span className="font-bold">English:</span> mysalaryloan.com is not responsible for losses from payments to unverified persons or links.
                </p>
                <p className="text-[#2C3E50]/80 mt-2 text-sm md:text-base">
                  <span className="font-bold">हिंदी:</span> mysalaryloan.com अनधिकृत व्यक्तियों या लिंक को भुगतान से होने वाले नुकसान के लिए जिम्मेदार नहीं है।
                </p>
              </div>
            </div>
          </div>

          {/* Official Link Box */}
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
            <div className="flex gap-3">
              <div className="flex-shrink-0">
                <svg className="w-6 h-6 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-[#2C3E50] text-sm md:text-base">
                  <span className="font-bold">English:</span> Pay only through our official website or authorized link.
                </p>
                <p className="text-blue-600 font-bold text-base md:text-lg mt-2">
                  mysalaryloan.com
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Button */}
        <div className="p-6 pt-0">
          <button
            onClick={onConfirm}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 md:py-4 rounded-xl transition text-base md:text-lg"
          >
            I Understand / मैं समझ गया
          </button>
        </div>
      </div>
    </div>
  );
};

export default SecurityAlert;
